var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionTimer = function SvgQuestionTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M29.044 4.13A2.5 2.5 0 0 0 27.148 0h-10a2.5 2.5 0 0 0-1.895 4.13C6.76 7.003.648 15.038.648 24.5c0 11.874 9.626 21.5 21.5 21.5 11.875 0 21.5-9.626 21.5-21.5 0-9.462-6.112-17.497-14.604-20.37ZM22.148 7c-9.665 0-17.5 7.835-17.5 17.5S12.483 42 22.148 42s17.5-7.835 17.5-17.5S31.813 7 22.148 7Zm-1.5 19.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 1 0 0-3h-5.5v-8.5a1.5 1.5 0 1 0-3 0v10Z"
  })));
};
export default SvgQuestionTimer;